import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

import { AppContext } from "../Context/Provider";

const EventsCovers = () => {
  const { FetchEventCover, EventCoverData } = useContext(AppContext);

  useEffect(() => {
    FetchEventCover();
  }, []);

  // console.log("hello......");
  return (
    <>
      {EventCoverData?.map((el) => (
        <div
          className="relative bg-cover bg-center bg-no-repeat w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[680px] rounded-lg overflow-hidden shadow-lg"
          style={{
            backgroundImage: `url(${el.fileName})`,
            marginTop: "10px",
            transition: "background-image 0.5s ease-in-out",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >

        </div>
      ))}
    </>
  );
};

export default EventsCovers;
